/**
 * Holds the Cognito **ID token** chat v1 sends as `Authorization: Bearer` on the HTTP API
 * and to mint ws-tickets. Nothing in the app held a token before — the rest authenticates
 * with a session cookie — so this is a new, self-contained holder (module singleton, the
 * same shape as http.ts's `csrfToken`).
 *
 * Two sources, in priority order:
 *  1. `setChatv1Token()` — set in memory by the real Google→Cognito flow once it lands, or
 *     by a test.
 *  2. `av_chatv1_dev_token` in localStorage — the DEV stub (mint one with the admin flow on
 *     aowl and paste it in). v1 login is stubbed on this until the OAuth secret + redirect
 *     URI are wired (CHATV1 §1), at which point (1) supersedes it.
 *
 * A token is a short-lived JWT; refresh belongs to the real flow (not built yet).
 */
let token: string | null = null

export function setChatv1Token(jwt: string | null): void {
  token = jwt
}

export function chatv1Token(): string | null {
  if (token) return token
  try {
    const seed = localStorage.getItem('av_chatv1_dev_token')
    if (seed) return (token = seed)
  } catch {
    /* storage disabled */
  }
  return null
}

export function hasChatv1Token(): boolean {
  return chatv1Token() != null
}
